import axios from '../../../../api/axios';
import React,{useState,useEffect} from 'react'
//import Formulaire from '../../../ModelesPages/Modele1/FormulaireClasse_initiale'
import Swal from 'sweetalert2';

function Insertion(){
    const [Count,setCount]=useState(0);
    const [sections,setSections]=useState([])
    const [section,setSection]=useState("")
    const [niveau,setNiveau]=useState("")
    const [nom,setNom]=useState("")
    const [data,setData]=useState([])
    const record=sections.filter(secti => Number(secti.id) === Number(section))
    
    const csrf=async()=>axios.get('sanctum/csrf-cookie')
    useEffect(()=>{            

        HandleRequest()
    },[])
    useEffect(()=>{
        if(section!=="" && niveau!==""){
            setData(record[0])
            if(niveau==="1"){
                setNom(niveau+'ère '+data?.nom)
               }
            else{
                setNom(niveau+'ème '+data?.nom)
               }
               console.log(record)
        }
    },[section,niveau])
   
   
    const HandleRequest=async()=>{
        await axios.get('/api/Section').then((res)=>{
            setSections(res.data.items)
        }).catch((err)=>{
        })
    }
    function confirmSave(e){
        e.preventDefault()
        if(nom !==""){
        Swal.fire({
            title:'Demande de confirmation',
            text:'Voulez-vous vraiment enregistrer ce cours ?',
            icon:'question',
            showCancelButton:true,
            showConfirmButton:true,
            confirmButtonText:'Confirmer',
        }).then((resultat)=>{
            if(resultat.isConfirmed){
                HandleSubmit()
            }
        })  
        }
        else{
            Swal.fire({
                title:'Erreur de soumission',
                text:'Veuillez d\'abord confirmer le nom du cours',
                icon:'warning'
            })
        }
    }
    const handleChangeSection=(e)=>{
        setSection(e.target.value)
        setData(record[0])
        setNiveau("")
       
    }
    function handleBlurSection(e){
       setSection(e)
       setData(record[0])
       if(niveau===1){
        setNom(niveau+'ère '+data?.nom)
       }
       else{
        setNom(niveau+'ème '+data?.nom)
       }
       
    }
    function handleChangeNiveau(e){
        setNiveau(e)
       setData(record[0])
    }
    function handleBlurNiveau(e){
        setNiveau(e)
        
        setData(record[0])
        if(niveau===1){
            setNom(niveau+'ère '+data?.nom)
           }
           else{
            setNom(niveau+'ème '+data?.nom)
           }
     }
    const HandleSubmit=async (e)=>{
                await axios.post('/api/classeinitiale',{nom:nom.toLowerCase(),section:section,niveau:niveau}).then((res)=>{
                    setNom("")
                    setNiveau("")
                    setSection("")
                    if(res.data.status_code===200){
                        Swal.fire({
                            title:'Message de confirmation',
                            text:'La classe a été enregistrée avec succès',
                            icon:'success'
                            
                        })
                    }
                    else{
                        Swal.fire({
                            title:'Message d\'erreur',
                            text:res.data.status_message,
                            icon:'error'
                            
                        })
                    }
                     
                }).catch((err)=>{
                        document.getElementById("erreur").innerHTML=err
                        
                        
                })
    }
    return(
    <>

   { /*<Formulaire title="Formulaire d'inscription" handleBlurNiveau={handleBlurNiveau} handleBlurSection={handleBlurSection} confirmSave={confirmSave} setNom={setNom}   nom={nom}   Count={Count} setCount={setCount} HandleSubmit={HandleSubmit} niveau={niveau} setNiveau={setNiveau} section={section} setSection={setSection} sections={sections} setSections={setSections} handleChangeNiveau={handleChangeNiveau} handleChangeSection={handleChangeSection} >
        <div className="w-full md:w-1/1 px-3  md:mb-0">
        
        <div id="resultat" className="block text-red-700"></div>
        <div id="erreur" className="block text-red-500"></div>
    </div>
    </Formulaire>
    */
    }
 <div className="container align-items-center">
                <form  onSubmit={confirmSave}>
                    <legend>
                        <h3 className="font-bold text-blue-500 mb-4 text-xl">
                            Ajout de la classe
                        </h3>
                    </legend>
                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <div class="form-outline">
                                <label class="form-label" for="firstName">Section</label>
                                <select name="section" id="section" className="form-control form-select-lg" onChange={handleChangeSection} value={section}>
                                <option value="" selected disabled>Choix de la section</option>
                                {
                                    sections.map((sect)=>
                                        <option value={sect.id} key={sect.id} >{sect.nom}</option>
                                    )
                                }
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <div class="form-outline">
                                <label class="form-label" for="firstName">NIVEAU</label>
                                <select name="section" id="niveau" className="form-control form-select-lg" value={niveau} onChange={(e)=>handleChangeNiveau(e.target.value)} >
                                <option value="" selected disabled>Niveau de la classe</option>
                                    {section === "1" ? (
                                        <>
                                            <option value="7">7ème</option>
                                            <option value="8">8ème</option>
                                        </>
                                        ) : (
                                        <>
                                            <option value="1">1ère</option>
                                            <option value="2">2ème</option>
                                            <option value="3">3ème</option>
                                            <option value="4">4ème</option>
                                        </>
                                    )}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <div class="form-outline">
                                <label class="form-label" for="firstName">CLASSE</label>
                                <input type="text" id="nomclasse" class="form-control form-control-lg" value={nom}  />                          
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <button className="btn btn-primary" type="submit" name="soumettre" id="submit">Submit</button>
                        </div>
                    </div>

                </form>
            </div>
    </>
    )
}
export default Insertion